import { createRouter, createWebHistory } from 'vue-router'
import AboutView from '../views/Ettevottest/AboutView.vue'
import ContactView from '../views/ContactView.vue'
import PostView from "@/views/News/PostView";
import EditPost from "@/views/News/EditPost";
import AddPost from "@/views/News/AddPost";
import ProductView from "@/views/Products/ProductView";
import EditProduct from "@/views/Products/EditProduct";
import AddProduct from "@/views/Products/AddProduct";
import ViewProduct from "@/views/Products/ViewProduct";
import ServiceView from "@/views/Services/ServiceView";
import HuviringidView from "@/views/Services/Huviringid/HuviringidView";
import Cart from "@/views/Products/Cart";
import SignUp from "@/views/Admin/SignUp";
import LogIn from "@/views/Admin/LogIn";
import auth from "../auth";
import ViewPost from "@/views/News/ViewPost";
import FounderView from "@/views/Ettevottest/FounderView";
import ProductInfoView from "@/views/Products/ProductInfoView";
import EventsView from "@/views/Services/Events/UritusedView";
import HomeView from "@/views/Home/HomeView";
import AddFeedback from "@/views/Home/AddFeedback";
import EditFeedback from "@/views/Home/EditFeedback";
import LohnastusedView from "@/views/Services/Lohnastused/LohnastusedView";
import MeeskonnadView from "@/views/Services/Meeskonnad/MeeskonnadView";
import AddLohnastus from "@/views/Services/Lohnastused/AddLohnastus";
import AddMeeskond from "@/views/Services/Meeskonnad/AddMeeskond";
import AddUritus from "@/views/Services/Events/AddUritus";
import EditUritus from "@/views/Services/Events/EditUritus";
import AddHuviring from "@/views/Services/Huviringid/AddHuviring";
import EditHuviring from "@/views/Services/Huviringid/EditHuviring";
import EditLohnastus from "@/views/Services/Lohnastused/EditLohnastus";
import EditMeeskond from "@/views/Services/Meeskonnad/EditMeeskond";
import EditProductInfo from "@/views/Products/EditProductInfo";
import EditAbout from "@/views/Ettevottest/EditAbout";
import EditFounder from "@/views/Ettevottest/EditFounder";
import EditEraklient from "@/views/Services/EditEraklient";
import EditAriklient from "@/views/Services/EditAriklient";
import AddEditCategory from "@/views/Products/AddEditCategory";
import EditInfo from "@/views/Services/Events/EditInfo";
import EditMeeskondInfo from "@/views/Services/Meeskonnad/EditMeeskondInfo";
import Privacy from "@/views/Admin/Privacy";
import NinatrennView from "@/views/Products/Ninatrenn/NinatrennView.vue";
import EditNinatrenn from "@/views/Products/Ninatrenn/EditNinatrenn.vue";
import EditNinatrennInfo from "@/views/Products/Ninatrenn/EditNinatrennInfo.vue";
import KinkekaardidView from "@/views/Products/Kinkekaardid/KinkekaardidView.vue";
import AddKinkekaart from "@/views/Products/Kinkekaardid/AddKinkekaart.vue";
import EditKinkekaart from "@/views/Products/Kinkekaardid/EditKinkekaart.vue";
import EditKinkekaartInfo from "@/views/Products/Kinkekaardid/EditKinkekaartInfo.vue";
import EditLohnastusInfo from '@/views/Services/Lohnastused/EditLohnastusInfo.vue';

const routes = [
  {
    path: "/",
    name: "Avaleht",
    children: [
      {
        path: "",
        name: "avaleht",
        component: HomeView,
      },
      {
        path: "/addfeedback",
        name: "Uus tagasiside",
        component: AddFeedback,
        beforeEnter: async(to, from, next) => {
          let authResult = await auth.authenticated();
          if (!authResult) {
            next('/')
          } else {
            next();
          }
        }
      },
      {
        path: "/editfeedback/:id",
        name: "Muuda tagasisidet",
        component: EditFeedback,
        beforeEnter: async(to, from, next) => {
          let authResult = await auth.authenticated();
          if (!authResult) {
            next('/')
          } else {
            next();
          }
        }
      },
    ]
  },
  {
    path: "/privaatsuspoliitika",
    name: "Privaatsuspoliitika",
    component: Privacy,
  },
  {
    path: "/asutajast",
    name: "asutajast",
    children: [
      {
        path: "",
        name: "Asutajast",
        component: FounderView
      },
      {
        path: "editfounder",
        name: "Muuda asutajast",
        component: EditFounder,
        beforeEnter: async(to, from, next) => {
          let authResult = await auth.authenticated();
          console.log(authResult);
          if (!authResult) {
            next('/')
          } else {
            next();
          }
        }
      }
    ]
  },
  {
    path: "/meist",
    name: "meist",
    children: [
       {
        path: "",
        name: "Meist",
        component: AboutView
      },
      {
        path: "editabout",
        name: "Muuda meist",
        component: EditAbout,
        beforeEnter: async(to, from, next) => {
          let authResult = await auth.authenticated();
          if (!authResult) {
            next('/')
          } else {
            next();
          }
        }
      }
    ]
  },
  {
    path: "/kontakt",
    name: "Kontakt",
    component: ContactView,
  },
  {
    path: "/uudised",
    name: "uudised",
    children: [
      {
          path: "",
          name: "Uudised",
          component: PostView,
      },
      {
        path: ":id",
        name: "Postitus",
        component: ViewPost,
        meta: { dynamicName: true },
      },
      {
        path: "editpost/:id",
        name: "Muuda uudist",
        component: EditPost,
        beforeEnter: async(to, from, next) => {
          let authResult = await auth.authenticated();
          if (!authResult) {
            next('/')
          } else {
            next();
          }
        }
      },
      {
        path: "addpost",
        name: "Uus uudis",
        component: AddPost,
        beforeEnter: async(to, from, next) => {
          let authResult = await auth.authenticated();
          if (!authResult) {
            next('/')
          } else {
            next();
          }
        }
      },
    ]
  },
  {
    path: "/tooteinfo",
    name: "Tooteinfo",
    children : [
      {
        path: "",
        name: "tooteinfo",
        component: ProductInfoView,
      },
      {
        path: "editinfo",
        name: "Muuda tooteinfot",
        component: EditProductInfo,
        beforeEnter: async(to, from, next) => {
          let authResult = await auth.authenticated();
          if (!authResult) {
            next('/')
          } else {
            next();
          }
        }
      }
    ]
  },
  {
    path: "/tooted",
    name: "Tooted",
    children: [
      {
        path: "",
        name: "tooted",
        component: ProductView
      },
      {
        path: "addeditcategory",
        name: "Lisa/Muuda",
        component: AddEditCategory,
        beforeEnter: async(to, from, next) => {
          let authResult = await auth.authenticated();
          if (!authResult) {
            next('/')
          } else {
            next();
          }
        }
      },
      {
        path: ":categoryPath(.*)/editproduct/:id(\\d+)",
        name: "EditProduct",
        component: EditProduct,
        meta: { dynamicName: true },
        props: (route) => ({ category: route.params.categoryPath, id: route.params.id }),
        beforeEnter: async(to, from, next) => {
          let authResult = await auth.authenticated();
          if (!authResult) {
            next('/')
          } else {
            next();
          }
        }
      },
      {
        path: ":categoryPath(.*)/:id(\\d+)",
        name: "Product",
        component: ViewProduct,
        meta: { dynamicName: true },
      },
      {
        path: ":categoryPath(.*)",
        name: "ToodeteKategooriad",
        component: ProductView,
        props: (route) => ({ category: route.params.categoryPath }),
        meta: { dynamicName: true },
      },
      {
        path: "ostukorv",
        name: "ostukorv",
        component: Cart
      },
      {
        path: "/addproduct",
        name: "Uus toode",
        component: AddProduct,
        beforeEnter: async(to, from, next) => {
          let authResult = await auth.authenticated();
          if (!authResult) {
            next('/')
          } else {
            next();
          }
        }
      },
    ]
  },
  {
    path: "/teenused",
    name: "Teenused",
    children: [
      {
        path: "",
        name: "teenused",
        component: ServiceView,
      },
      {
        path: "editeraklient",
        name: "Muuda eraklienti",
        component: EditEraklient,
        beforeEnter: async(to, from, next) => {
          let authResult = await auth.authenticated();
          if (!authResult) {
            next('/')
          } else {
            next();
          }
        }
      },
      {
        path: "editariklient",
        name: "Muuda äriklienti",
        component: EditAriklient,
        beforeEnter: async(to, from, next) => {
          let authResult = await auth.authenticated();
          if (!authResult) {
            next('/')
          } else {
            next();
          }
        }
      },
      {
        path: "uritused",
        name: "Ürituste programmid",
        children: [
          {
            path: "",
            name: "ürituste programmid",
            component: EventsView
          },
          {
            path: "adduritus",
            name: "Uus üritus",
            component: AddUritus,
            beforeEnter: async(to, from, next) => {
              let authResult = await auth.authenticated();
              if (!authResult) {
                next('/')
              } else {
                next();
              }
            }
          },
          {
            path: "edituritus/:id",
            name: "Muuda üritust",
            component: EditUritus,
            beforeEnter: async(to, from, next) => {
              let authResult = await auth.authenticated();
              if (!authResult) {
                next('/')
              } else {
                next();
              }
            }
          },
          {
            path: "editinfo",
            name: "Muuda infot",
            component: EditInfo,
            beforeEnter: async(to, from, next) => {
              let authResult = await auth.authenticated();
              if (!authResult) {
                next('/')
              } else {
                next();
              }
            }
          },
        ]
      },
      {
        path: "huviringid",
        name: "Huviringid",
        children: [
          {
            path: "",
            name: "huviringid",
            component: HuviringidView,
          },
          {
            path: "addhuviring",
            name: "Uus huviring",
            component: AddHuviring,
            beforeEnter: async(to, from, next) => {
              let authResult = await auth.authenticated();
              if (!authResult) {
                next('/')
              } else {
                next();
              }
            }
          },
          {
            path: "edithuviring/:id",
            name: "Muuda huviringi",
            component: EditHuviring,
            beforeEnter: async(to, from, next) => {
              let authResult = await auth.authenticated();
              if (!authResult) {
                next('/')
              } else {
                next();
              }
            }
          },
        ]
      },
      {
        path: "meeskonnakoolitused",
        name: "Meeskonnakoolitused",
        children: [
          {
            path: "",
            name: "meeskonnakoolitused",
            component: MeeskonnadView,
          },
          {
            path: "addmeeskond",
            name: "Uus meeskonnakoolitus",
            component: AddMeeskond,
            beforeEnter: async(to, from, next) => {
              let authResult = await auth.authenticated();
              if (!authResult) {
                next('/')
              } else {
                next();
              }
            }
          },
          {
            path: "editmeeskond/:id",
            name: "Muuda meeskonnakoolitust",
            component: EditMeeskond,
            beforeEnter: async(to, from, next) => {
              let authResult = await auth.authenticated();
              if (!authResult) {
                next('/')
              } else {
                next();
              }
            }
          },
          {
            path: "editmeeskondinfo",
            name: "Muuda meeskondade infot",
            component: EditMeeskondInfo,
            beforeEnter: async(to, from, next) => {
              let authResult = await auth.authenticated();
              if (!authResult) {
                next('/')
              } else {
                next();
              }
            }
          }
        ]
      },
      {
        path: "lohnastuslahendused",
        name: "Lõhnastuslahendused",
        children: [
          {
            path: "",
            name: "lõhnastuslahendused",
            component: LohnastusedView,
          },
          {
            path: "addlohnastus",
            name: "Uus lõhnastuslahendus",
            component: AddLohnastus,
            beforeEnter: async(to, from, next) => {
              let authResult = await auth.authenticated();
              if (!authResult) {
                next('/')
              } else {
                next();
              }
            }
          },
          {
            path: "editlohnastus/:id",
            name: "Muuda lõhnastuslahendust",
            component: EditLohnastus,
            beforeEnter: async(to, from, next) => {
              let authResult = await auth.authenticated();
              if (!authResult) {
                next('/')
              } else {
                next();
              }
            }
          },
          {
            path: "editlohnastusinfo",
            name: "Muuda lõhnastuslahenduse infot",
            component: EditLohnastusInfo,
            beforeEnter: async(to, from, next) => {
              let authResult = await auth.authenticated();
              if (!authResult) {
                next('/')
              } else {
                next();
              }
            }
          },
        ]
      },
    ]
  },
  {
    path: "/ninatrenn",
    name: "Ninatrenn",
    children: [
      {
        path: "",
        name: "ninatrenn",
        component: NinatrennView
      },
      {
        path: "editninatrenn",
        name: "Muuda ninatrenni",
        component: EditNinatrenn,
        beforeEnter: async(to, from, next) => {
          let authResult = await auth.authenticated();
          if (!authResult) {
            next('/')
          } else {
            next();
          }
        }
      },
      {
        path: "editninatrenninfo",
        name: "Muuda ninatrenni infot",
        component: EditNinatrennInfo,
        beforeEnter: async(to, from, next) => {
          let authResult = await auth.authenticated();
          if (!authResult) {
            next('/')
          } else {
            next();
          }
        }
      }
    ]
  },
  {
    path: "/kinkekaardid",
    name: "Kinkekaardid",
    children: [
      {
        path: "",
        name: "kinkekaardid",
        component: KinkekaardidView,
      },
      {
        path: "addkinkekaart",
        name: "Uus kinkekaart",
        component: AddKinkekaart,
        beforeEnter: async(to, from, next) => {
          let authResult = await auth.authenticated();
          if (!authResult) {
            next('/')
          } else {
            next();
          }
        }
      },
      {
        path: "editkinkekaart/:id",
        name: "Muuda kinkekaarti",
        component: EditKinkekaart,
        beforeEnter: async(to, from, next) => {
          let authResult = await auth.authenticated();
          if (!authResult) {
            next('/')
          } else {
            next();
          }
        }
      },
      {
        path: "editkinkekaartinfo",
        name: "Muuda kinkekaardi infot",
        component: EditKinkekaartInfo,
        beforeEnter: async(to, from, next) => {
          let authResult = await auth.authenticated();
          if (!authResult) {
            next('/')
          } else {
            next();
          }
        }
      }
    ]
  },
  
  {
    path: "/:catchAll(.*)",
    name: "Login",
    component: HomeView
  },
  {
    path: "/register",
    name: "Register",
    component: SignUp,
  },
  {
    path: "/admin",
    name: "LogIn",
    component: LogIn
  }
]

const CANONICAL_ORIGIN = 'https://lohnakas.ee'

const ensureHeadTag = (selector, createTag) => {
  let element = document.head.querySelector(selector)
  if (!element) {
    element = createTag()
    document.head.appendChild(element)
  }
  return element
}

const updateCanonicalTags = (routePath = '/') => {
  if (typeof document === 'undefined') return

  const normalizedPath = routePath.startsWith('/') ? routePath : `/${routePath}`
  const canonicalUrl = `${CANONICAL_ORIGIN}${normalizedPath}`

  const canonicalLink = ensureHeadTag('link[rel="canonical"]', () => {
    const link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    return link
  })

  canonicalLink.setAttribute('href', canonicalUrl)

  const ogUrlMeta = ensureHeadTag('meta[property="og:url"]', () => {
    const meta = document.createElement('meta')
    meta.setAttribute('property', 'og:url')
    return meta
  })

  ogUrlMeta.setAttribute('content', canonicalUrl)
}

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return new Promise((resolve) => {
        const maxAttempts = 40;
        let attempts = 0;

        const restoreScroll = () => {
          const viewportHeight = window.innerHeight;
          const documentHeight = document.documentElement.scrollHeight;
          const maxTop = Math.max(0, documentHeight - viewportHeight);
          const targetTop = Number(savedPosition.top) || 0;

          if (maxTop >= targetTop || attempts >= maxAttempts) {
            resolve({
              left: Number(savedPosition.left) || 0,
              top: Math.min(targetTop, maxTop),
              behavior: 'auto',
            });
            return;
          }

          attempts += 1;
          requestAnimationFrame(restoreScroll);
        };

        requestAnimationFrame(restoreScroll);
      });
    }

    return { top: 0, left: 0, behavior: 'auto' };
  }
})

router.afterEach((to) => {
  updateCanonicalTags(to.path)
})

updateCanonicalTags(router.currentRoute.value.path)

export default router